/* tslint:disable:import-spacing component-class-suffix no-inferrable-types variable-name
   typedef-whitespace component-selector no-trailing-whitespace */

import {
  AfterViewInit,
  OnDestroy,
  Component,
  HostListener,
  Input
}                            from '@angular/core';

import {
  BehaviorSubject,
  Observable,
  Subscription
}                            from 'rxjs';


import * as $                from 'jquery';

import {WorkBlock}           from '@/models/scenario/work.block';
import {Scenario}            from '@/models/scenario/scenario';
import {Logger}              from '@/util/logger';
import {UnDoRedo}            from '@/util/un.do.redo';
import {WorkBlockChange}     from '@/screens/ide/workblox/work.block.change';
import {WorkBlockInlineEdit} from './work.block.inline.edit';

@Component({
  selector: 'work-blox-summary-graph',
  template: `
    <div id="work-blox-graph-container_{{uuid}}" class="work-blox-graph-container" style="">
      <p
        id="graph-work-blox-graph_{{uuid}}"
        style="width: 100%; height: 100%;">

        Hello I'm a graph.

      </p>
    </div>
    `
})

/**
 *
 * @class WorkBloxSummaryGraph
 *
 * @brief @brief this table shows a tabular summary of all work blocks in the current
 * scenario.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      November 2019
 *
 */
export class WorkBloxSummaryGraph implements AfterViewInit, OnDestroy {

  @Input() uuid: number           = 0;

  /** the history manager (not owned by us */
  private _history: UnDoRedo      = null;

  /** @var _scenario the scenario model */
  private _scenario: Scenario     = null;

  /** the currently active row/selection/workblock */
  private selectedWorkBlock: BehaviorSubject<WorkBlockChange>     = null;
  private         selectSub: Subscription                         = null;

  private    lastInlineEdit: BehaviorSubject<WorkBlockInlineEdit> = null;
  private           editSub: Subscription                         = null;

  private isFullScreen: boolean   = false;

  public context = {

    workBloxTable: this

  };

  public toggleFullScreen() {

    if (this.isFullScreen) {

      Logger.debug('[workblox/graph] exiting full screen...');

      document.exitFullscreen();

    } else {

      Logger.debug('[workblox/graph] going full screen...');

      const elem = document.getElementById(`graph-work-blox-graph_${this.uuid}`);

      if (elem.requestFullscreen) {

        elem.requestFullscreen();
      }
    }

  }

  ngOnDestroy(): void {

    if (this.selectSub !== null) {

      /* unsubscribe our observer */

      this.selectSub.unsubscribe();
    }

    if (this.editSub !== null) {

      /* unsubscribe our observer */

      this.editSub.unsubscribe();
    }
  }

  /** @brief first time setup of view */
  ngAfterViewInit() {

    Logger.debug('[workblox/graph] view init...');

    this.clear();

    const        elem = document.getElementById(`graph-work-blox-graph_${this.uuid}`);
    const gcTimeTable = this;

    elem.addEventListener('fullscreenchange', () => {

      gcTimeTable.isFullScreen = document.fullscreenElement != null;

      Logger.debug('[workblox/graph] (elem) flipped full screen mode: ', gcTimeTable.isFullScreen);

    }, true);
  }

  /** @brief reset the view to empty */
  public clear() {

    this._scenario = null;
  }

  /** @brief standard destructor */
  destroy() {

    Logger.debug('[workblox/graph] cleaning up...');

  }

  /** take a reference to the shared history manager (provides undo/redo support) */
  public setHistory(history: UnDoRedo): void {

    this._history = history;
  }

  /** @brief set the table base on this scenario */
  setScenario(scenario: Scenario = null): boolean {

    if (scenario == null) {

      this.clear();

      return true;
    }

    /* save the model */

    this._scenario                   = scenario;

    /* refresh the table based on currently selected train class */

    this.refreshTable();

    /* all done */

    return true;
  }

  /** set a new observer to use for watching for selection changes */
  public setSelectionSubject(selection: BehaviorSubject<WorkBlockChange>) {

    if (this.selectSub !== null) {

      /* unsubscribe old one */

      this.selectSub.unsubscribe();
    }

    /* subscribe to this selection watcher ... */

    this.selectedWorkBlock = selection;
    this.selectSub         = selection.subscribe( (next: WorkBlockChange) => {

      this.setSelected(next);
    });

  }

  /** allow selection from history */
  public doSelection(selection: WorkBlockChange) {

    /* TODO: */

  }

  /** @brief helper to update the graph  */
  public refreshGraph(): boolean {

    /* TODO: */



    /* all done */

    return true;
  }

  /** helper to clear the current selection */
  public clearSelection() {

    /* TODO: */


  }

  /** handle single column edits in the edit input area */
  setInlineEditSubject(edit: BehaviorSubject<WorkBlockInlineEdit>) {

    if (this.editSub !== null) {

      /* unsubscribe old one */

      this.editSub.unsubscribe();
    }

    /* subscribe to this selection watcher ... */

    this.lastInlineEdit = edit;
    this.editSub        = edit.subscribe( (next: WorkBlockInlineEdit) => {

      this.inlineEdited(next);
    });
  }

  /** handle single column changes in the editing inputs */
  public inlineEdited(edit: WorkBlockInlineEdit) {

    Logger.debug('[workblox/graph] inline edit', edit);

    /* TODO: */

  }

  /** handle somebody change the selection somewhere */
  public setSelected(change: WorkBlockChange) {

    if (change === null) {

      Logger.debug('[workblox/graph] clearing...');

      /* TODO: deselect all */

      return ;
    }

    /* check that we aren't calling ourself */

    if ( (change.src instanceof WorkBloxSummaryGraph) && (change.src === this)) {

      /* from self, ignore infinite looping! */

      return ;
    }

    /* handle the selection update */

    Logger.debug('[workblox/graph] selection change: ', change);





  }

  /** @brief helper to update the table w.r.t. a chosen train class */
  public refreshTable(): boolean {









    /* all done */

    return true;
  }

  @HostListener('window:resize')
  public resize() {

    Logger.debug('[workblox/graph]', 'resizing...');

    /* for now use horizontal scroll, table is getting really wide */
    /* this.gridApi.sizeColumnsToFit(); */
  }

}
